module.exports = __webpack_public_path__ + "static/media/farms.d02ec160.jpg";